import { render, staticRenderFns } from "./Co45Page.vue?vue&type=template&id=5a981c5d"
import script from "./Co45Page.vue?vue&type=script&lang=js"
export * from "./Co45Page.vue?vue&type=script&lang=js"
import style0 from "./Co45Page.vue?vue&type=style&index=0&id=5a981c5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports